import { Injectable } from '@angular/core';
import { ModalComponent } from '../modal/modal.component';
import { MatDialog } from '@angular/material/dialog';

@Injectable({
  providedIn: 'root'
})
export class MensajeService {

  readonly TIPO_INFO = 1;
  readonly TIPO_OK = 2;
  readonly TIPO_ERROR = 3;
  readonly TIPO_ADVERTENCIA = 4;

  constructor(
    public dialog: MatDialog,
  ) { }

  /**
   * 
   * @param mensaje : mensaje a mostrar.
   * @param title : titulo del modal.
   * @param tipo : tipo de mensaje que se mostrara usar las variables de clase TIPO_INFO, TIPO_OK, TIPO_ERROR, TIPO_ADVERTENCIA.
   * @param target : elemento que lanzar el evento.
   * @param json_botones : json con la informacion de los botones que se mostraran.
   */
  ver_mensaje(mensaje :string, title : string, tipo = this.TIPO_ADVERTENCIA, target = null, json_botones = null ) {
    return this.dialog
               .open(ModalComponent,{
                 data :{
                    mensaje,
                    title,
                    tipo,
                    target, 
                    botones : json_botones
                 },
                 width: '400px',
               });
  }
}
